import { sourceImage } from 'features/Ticket'
import { getImageFileName } from 'helpers/common'

export const getImageFromReporter = (fileUploads: string[]): sourceImage => {
  const imageList: sourceImage = []
  const isShowImage = fileUploads.length > 0

  if (isShowImage) {
    for (let i = 0; i < fileUploads.length; i++) {
      const obj: { src: string | undefined } = { src: undefined }
      obj.src = fileUploads[i]
        ? `${getImageFileName(fileUploads[i])}`
        : undefined
      imageList.push(obj)
    }
  }

  return imageList
}
